export const ApiBaseUrl = `/orderApi/orderSheet/familyPay`

export const ApiUrlInfo = {
    /** 주문서 조회 */
    orderSheet: '/',
    orderSheetReject: '/reject',
    payPoint: {
        /** 충전포인트와 적립포인트 잔액 재조회 */
        naverpayPointBalance: '/naverpayPointBalance',
        /** 적립 포인트 잔액 재조회 */
        rewardPointBalance: '/rewardPointBalance',
        /** 충전포인트 잔액 재조회 */
        chargePointBalance: '/chargePointBalance',
        /** 충전포인트 충전 가능 금액 재조회 */
        rechargeableChargePoint: '/rechargeableChargePoint',
    },
    payments: {
        /** 카드 간편결제 정보 재조회 */
        cardEasyPaysReload: '/cardEasyPays',
        /** 계좌 간편결제 정보 재조회 */
        bankEasyPaysReload: '/bankEasyPays',
    },
    /** 패밀리 대표 예상 적립 */
    expectedRewardPoint: '/expectedRewardPoint',
    /** 주문결과 */
    result: '/result',
}
